import { Button } from "@/lib/components/Button/Button";
import TransitionIcon from "./TransitionIcon";

type Props = {
  hasTransition: boolean;
  onClick: () => void;
};

export default function TransitionTriggerButton({
  hasTransition,
  onClick,
}: Props) {
  return (
    <Button
      variant="outline"
      size="iconXs"
      className="relative z-1000 scale-70 bg-white shadow-none transition-transform duration-200 hover:scale-100"
      onClick={onClick}
    >
      <TransitionIcon
        color={
          hasTransition ? "url(#icon-gradient)" : "var(--color-text-primary)"
        }
      />
    </Button>
  );
}
